module.exports = __webpack_public_path__ + "static/media/ae.5e394508.svg";